import React from 'react';
import * as S from './MobileVerified.styles';
import IconSelector from '@ibibo/icon-selector';

const MobileVerified = ({closePop, mobile, email}) => {
  return (
    <S.EmailVerifyPopWrap>
      <S.EmailVerifyPopContentWrap>
        <S.EmailVerifyPopHeadWrap>
          <S.PopupCloseBtn onClick={closePop}>
            <IconSelector iconKey="close" props={{fill: '#fff', width: '1rem', height: '1rem'}} />
          </S.PopupCloseBtn>
        </S.EmailVerifyPopHeadWrap>
        <S.EmailVerifyBodyWrap>
          <S.EmailVerifiedTopWrap>
            {/* <S.EmailVerifiedImgWrap>
                        
                        </S.EmailVerifiedImgWrap> */}
            <S.EmailVerifiedInfoWrap>
              <S.EmailVerifyMainText>Mobile Updation Successful</S.EmailVerifyMainText>
              <S.EmailVerifyInfoText>
                Congrats! Your myPartner account is now linked to mobile number:
                <strong>+91-{mobile}</strong>
              </S.EmailVerifyInfoText>
            </S.EmailVerifiedInfoWrap>
          </S.EmailVerifiedTopWrap>
          <S.EmailVerifiedBottomWrap>
            <S.EmailVerifyInfoText>
              <sub>*</sub>Note: This mobile number {mobile} will serve as the username for all your
              MakeMyTrip accounts link to this email ID: {email}
            </S.EmailVerifyInfoText>
          </S.EmailVerifiedBottomWrap>
        </S.EmailVerifyBodyWrap>
      </S.EmailVerifyPopContentWrap>
    </S.EmailVerifyPopWrap>
  );
};

export default MobileVerified;
